import {AllowPrivateMessages, ClientUser, Roles, Sex} from "../../../shared/user";

export class RoomClientUsersWrapper implements ClientUser{
    constructor(private readonly _clientUser: ClientUser,
                readonly isMe: boolean,
                private readonly _userType: UserRoomRole,
                readonly online: boolean = true) {
    }

    get invisible(): boolean {
        return this._clientUser.invisible
    }

    get allowPrivateMessages(): AllowPrivateMessages {
        return this._clientUser.allowPrivateMessages
    }

    get login(): string {
        return this._clientUser.login
    }

    get sex(): Sex {
        return this._clientUser.sex
    }

    /**
     * Глобальные роли модератора
     */
    get roles(): Roles[] {
        return this._clientUser.roles
    }

    get willDelete(): number {
        return this._clientUser.willDelete
    }

    get registered(): boolean {
        return this._clientUser.registered
    }

    get premiumUntil(): number {
        return this._clientUser.premiumUntil
    }

    get boostInUsersList(): boolean {
        return this._clientUser.boostInUsersList
    }

    get avatarPath(): string {
        return this._clientUser.avatarPath
    }

    get userType(): UserRoomRole {
        return this._userType
    }

    getRealUser(): ClientUser {
        return {
            login: this.login,
            sex: this.sex,
            roles: this.roles,
            registered: this.registered,
            invisible: this.invisible,
            allowPrivateMessages: this.allowPrivateMessages,
            premiumUntil: this.premiumUntil,
            boostInUsersList: this.boostInUsersList,
            willDelete: this.willDelete,
            avatarPath: this.avatarPath
        };
    }
}

export enum UserRoomRole {
    usualUser,
    localModerator,
    localAdministrator
}